module.exports = __webpack_public_path__ + "media/images/app/products/calendar-152c0bc84f8b82708e6f3bc6ef7285b9.svg";